var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6175 5.34323C15.6281 5.49128 15.6281 5.63936 15.6281 5.7874C15.6281 10.303 12.1911 15.5061 5.90941 15.5061C3.97412 15.5061 2.17633 14.9456 0.664062 13.9727C0.93903 14.0044 1.20339 14.015 1.48893 14.015C3.08577 14.015 4.55576 13.4757 5.72962 12.5556C4.22793 12.5239 2.96947 11.5404 2.53587 10.1867C2.7474 10.2184 2.95889 10.2396 3.18099 10.2396C3.48766 10.2396 3.79437 10.1973 4.07988 10.1233C2.51475 9.80599 1.34085 8.43122 1.34085 6.7709V6.72861C1.79557 6.98242 2.32438 7.14105 2.88483 7.16217C1.96478 6.5488 1.36201 5.50186 1.36201 4.31742C1.36201 3.68291 1.53118 3.10127 1.82731 2.59365C3.50879 4.66641 6.0363 6.02002 8.87044 6.1681C8.81758 5.91429 8.78584 5.64994 8.78584 5.38555C8.78584 3.50313 10.3087 1.96973 12.2017 1.96973C13.1852 1.96973 14.0735 2.38216 14.6974 3.04841C15.4694 2.90036 16.2097 2.61481 16.8654 2.22354C16.6115 3.0167 16.0722 3.68294 15.3637 4.10592C16.0511 4.03193 16.7173 3.84154 17.3307 3.57718C16.8654 4.25397 16.2838 4.85674 15.6175 5.34323Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.652dfd5f8977ed3ac803cc3ecdc2f3a5.svg";
export { ForwardRef as ReactComponent };